// extracted by mini-css-extract-plugin
export default {"root":"_3Tydp","large":"jv6FI","hoverable":"_1u4dt","medium":"_1akvw","small":"_1I0yh"};